<template>
  <v-content v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-row class="rows btn-group">
      <v-select v-model="year"
                :items="yearList"
                @change="getChartData"
                dense
                solo></v-select>
    </v-row>

    <v-flex class="table-style">
      <ve-histogram :data="chartData"
                    :settings="chartSettings"></ve-histogram>
    </v-flex>

    <v-flex class="table-style2">
      <ve-pie :data="chartData"
              :settings="chartSettings"></ve-pie>
    </v-flex>

    <!-- <v-flex class="count-style">
        <v-row class="count-row">
          <font>本月登录总次数</font>
          <v-spacer></v-spacer>
          <font>次</font>
        </v-row>

        <v-row class="count-row">
          <font>本月员工登录次数</font>
          <v-spacer></v-spacer>
          <font>次</font>
        </v-row>
      </v-flex> -->

  </v-content>
</template>


<script>
import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口


export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      isLoading: false,
      chartSettings: {
        labelMap: {
          'month': '月份',
          'count': '访问次数'
        }
      },
      year: 2020,
      yearList: [
        { text: "2020", value: 2020 },
        { text: "2021", value: 2021 },
        { text: "2022", value: 2022 },
        { text: "2023", value: 2023 }
      ],
      chartData: {
        columns: ['month', 'count'],
        rows: []
      },
    }
  },
  created () {
    this.init();
  },
  mounted () {
    this.$emit("updateNavigationValue", 5)
    this.init();
  },
  methods: {
    init () {
      this.getChartData();
      this.loading = true;
    },

    getChartData () {
      this.isLoading = true;
      this.$store
        .dispatch("GetViewedData", this.year)
        .then(response => {
          var data = response.data.data;
          this.chartData.rows = data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
}
.btn-group >>> .v-input {
  width: 100px !important;
  flex: none;
}
.table-style {
  width: 98%;
  height: 500px;
  overflow: auto;
}
.table-style2 {
  width: 45%;
  overflow: auto;
}
.count-style {
  padding: 0 20px 0 20px;
  width: 45%;
}
.count-row {
  width: 200px;
}
</style>